<div class="grid tk-grid-rows place-items-center h-screen tk-bg-gray-1 tk-i-background">

  <div class="mx-auto flex-1 flex-col place-items-center w-80">

    <div class="mb-3 grid place-items-center">
      <div class="i-black-marker"></div>
    </div>

    <div class="text-lg font-semibold text-center">Sprawdź swój e-mail</div>

    <div class="mt-4 text-sm text-center">Wysłaliśmy Ci wiadomość na adres</div>

    <div class="mt-1 tk-c-blue text-sm text-center">{{email}}</div>

    <div class="mt-8 tk-c-gray text-xs">Nie dotarł do Ciebie e-mail?</div>

    <div class="mt-3 tk-c-gray text-xs">1. Zajrzyj do folderu ze spamem.</div>

    <div class=" tk-c-gray text-xs">2. Sprawdź, czy podany adres jest poprawny.</div>

    <div class="mb-8 tk-c-gray text-xs">3. Odczekaj chwilę i spróbuj ponownie.</div>

    <app-button label="Wróć do logowania" [isFullWidth]="true" innerTextClasses="my-1.5" spinnerClasses="my-3" (click)="onClick()"></app-button>

  </div>

  <am-login-footer class="mb-8 w-full"></am-login-footer>

</div>

